<template>
  <div>
    <el-card class="box-card">
      <el-form :inline="true">
        <el-form-item label="合同编号">
          <el-input v-model="query.contractNo" clearable style='width: 200px;' placeholder="请输入合同编号"></el-input>
        </el-form-item>
        <el-form-item label="支付状态" style="margin-left: 20px;">
          <el-select v-model="query.status" style='width: 200px;' clearable placeholder="请选择">
            <el-option v-for="(item, index) in $key.myAccount.paymentStatus" :key="index" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="支付时间" span="2" style="margin-left: 20px;">
          <el-date-picker
            clearable
            v-model="query.leftPayDate"
            type="date"
            placeholder="开始日期">
          </el-date-picker>
          -
          <el-date-picker
            clearable
            style="margin-right: 15px;"
            v-model="query.rightPayDate"
            type="date"
            placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item style="margin-left: 10px;">
          <el-button type="primary" @click="handleSearch"><i class="fa fa-search"> 查询</i>
          </el-button>
          <el-button type="primary" plain @click="handleReset"><i class="fa fa-refresh"> 重置</i>
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <!-- 导出 -->
    <inquery-result style="margin-bottom: 20px;" :isExport='false'></inquery-result>
    <z-table
      :current-page.sync="currentPage"
      :total="total"
      @current-change="changePage"
      @sort="changeSort"
    >
      <el-table
        :data="tableData"
        ref="zTable"
      >
        <el-table-column
          align="center"
          prop="contractNo"
          label="合同编号">
        </el-table-column>
        <el-table-column
          align="center"
          prop="paymentCode"
          label="支付单号">
        </el-table-column>
        <el-table-column
          align="center"
          prop="receiverSysAccountName"
          label="收款会员">
        </el-table-column>
        <el-table-column
          align="center"
          prop="contractAmount"
          label="合同金额(元)">
          <template slot-scope="scope">
            <span>
              {{scope.row.contractAmount | thousandMark}}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="contractDate"
          label="合同日期">
        </el-table-column>
        <el-table-column
          align="center"
          prop="payDate"
          label="支付时间">
        </el-table-column>
        <el-table-column
          align="center"
          prop="status"
          label="状态">
          <template slot-scope="scope">{{ scope.row.status | keyFilter("myAccount", "paymentStatus") }}</template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template v-slot="scope">
            <el-button type="text" @click="toDetail(scope.row)">详情</el-button>
            <el-button type="text" v-if="scope.row.status === 'UN_PAID' || scope.row.status === 'PAYING'" @click="toPay(scope.row)">支付</el-button>
          </template>
        </el-table-column>
      </el-table>
    </z-table>
    <div id="form-container"></div>
    <payment-detail v-if="showDetail" :detailData="detailData" @done="handleClose"></payment-detail>
  </div>
</template>

<script>
import paymentDetail from './payment-detail'
import api from '@/api'
import { formatTime } from '@/utils/util'

function Query () {
  this.contractNo = ''
  this.payerSysId = ''
  this.splitFlag = ''
  this.status = ''
  this.leftPayDate = ''
  this.rightPayDate = ''
}
export default {
  name: 'payment',
  components: {
    paymentDetail
  },
  data () {
    return {
      query: new Query(),

      currentPage: 1,
      total: 0,
      pageSize: 10,

      showDetail: false,
      detailData: {},

      tableData: []
    }
  },

  mounted () {
    this.fetchList(1)
  },
  created () {
  },
  destroyed () {
    this.$root.$off('refreshPaymentList')
  },
  methods: {
    async fetchList (currentNo, pageSize) {
      if (pageSize) {
        this.pageSize = pageSize
      }
      this.currentNo = currentNo || this.currentNo || 1
      let param = {
        ...this.query,
        marketId: '10102',
        bankCode: 'JDFC',
        currentNo: this.currentNo,
        pageSize: this.pageSize
      }
      param.leftPayDate = formatTime(this, this.query.leftPayDate)
      param.rightPayDate = formatTime(this, this.query.rightPayDate, 1)

      let res = await api.myAccount.fetchPaymentList(param)
      this.tableData = res.data.rows
      this.total = res.data.totalElements
    },
    async toDetail (row) {
      let param = {
        id: row.id
      }
      this.detailData = (await api.myAccount.paymentDetail(param)).data
      this.showDetail = true
    },
    handleReset () {
      this.query = new Query()
      this.fetchList(1)
    },
    // 查询
    handleSearch () {
      this.fetchList(1)
    },
    changePage (page) {
      this.fetchList(page)
    },
    changeSort (prop) {
      // console.log('重新获取表格内容，页数为第一页，排序为prop')
    },
    // 支付
    async toPay (row) {
      const param = {
        paymentCode: row.paymentCode
      }
      let res = await api.myAccount.toPay(param)
      const formContainer = document.getElementById('form-container')
      // 去掉"前的\
      formContainer.innerHTML = res.data.replace(/\\"/g, '"')
      const thisForm = formContainer.getElementsByTagName('form')[0]
      thisForm.target = '_blank'
      // 再次修改input内容
      thisForm.submit()
      this.handleClose()
    },
    // 关闭弹窗
    handleClose () {
      this.showDetail = false
    }
  }
}
</script>

<style lang="scss" scoped>
.adsf {
  background: red;
  color: #fff;
  height: 50px;
  line-height: 50px;
}
#form-container {
  visibility: hidden;
  position: absolute;
}
::v-deep .table-page-search-submitButtons{
  margin-left: 100px
}
</style>
